import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Restaurant, CustomerDeliveryAddress } from '@/models';

@Component({
  name: 'CmgGoogleMap',
})
export default class CmgGoogleMaps extends Vue {
  @Prop({ type: Object })
  selectedPickupRestaurant?: Restaurant;

  @Prop({ type: Object })
  selectedDeliveryAddress?: CustomerDeliveryAddress;

  @Prop({ required: true, type: Boolean })
  searchThisAreaActive!: boolean;

  @Prop({ default: false, type: Boolean })
  mapHeightOffset!: boolean;

  mounted() {
    this.$emit('element-mounted', this.$el);
  }

  get currentLocationImageUrl(): string {
    return this.$store.state.cms.images.buttons.currentLocation.default;
  }

  onCloseModal() {
    this.$emit('close-modal');
  }

  onFindAChipotleButton() {
    this.$emit('find-a-chipotle-button-clicked');
  }

  searchThisArea() {
    this.$emit('search-this-area');
  }

  findNearby() {
    this.$emit('find-nearby');
  }

  zoomIn() {
    this.$emit('zoom-in');
  }

  zoomOut() {
    this.$emit('zoom-out');
  }
}
